import React, { useEffect, useState, useRef, lazy } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  avatar: string;
}
const PURCHASES: Purchase[] = [{
  name: 'Luciana',
  city: 'La Plata',
  avatar: 'https://i.pravatar.cc/100?img=31'
}, {
  name: 'Martina',
  city: 'Córdoba',
  avatar: 'https://i.pravatar.cc/100?img=45'
}, {
  name: 'Sofía',
  city: 'Rosario',
  avatar: 'https://i.pravatar.cc/100?img=44'
}, {
  name: 'Camila',
  city: 'Mendoza',
  avatar: 'https://i.pravatar.cc/100?img=47'
}, {
  name: 'Valentina',
  city: 'Mar del Plata',
  avatar: 'https://i.pravatar.cc/100?img=32'
}, {
  name: 'Carla',
  city: 'Buenos Aires',
  avatar: 'https://i.pravatar.cc/100?img=20'
}, {
  name: 'Florencia',
  city: 'San Juan',
  avatar: 'https://i.pravatar.cc/100?img=49'
}, {
  name: 'Agustina',
  city: 'Salta',
  avatar: 'https://i.pravatar.cc/100?img=16'
}, {
  name: 'Julieta',
  city: 'Tucumán',
  avatar: 'https://i.pravatar.cc/100?img=48'
}, {
  name: 'Micaela',
  city: 'Neuquén',
  avatar: 'https://i.pravatar.cc/100?img=23'
}];
const TIME_AGO = ['hace 2 minutos', 'hace 5 minutos', 'hace instantes', 'hace 1 minuto', 'hace 8 minutos'];
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<(Purchase & {
    ago: string;
  }) | null>(null);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    const showNext = () => {
      const purchase = PURCHASES[indexRef.current % PURCHASES.length];
      const ago = TIME_AGO[Math.floor(Math.random() * TIME_AGO.length)];
      indexRef.current += 1;
      setCurrent({
        ...purchase,
        ago
      });
      // Hide after ~5s, then schedule the next one with a 5-10s gap
      timeoutRef.current = setTimeout(() => {
        setCurrent(null);
        const gap = 5000 + Math.random() * 5000;
        timeoutRef.current = setTimeout(showNext, gap);
      }, 5000);
    };
    // First notification appears 10s after the page loads
    timeoutRef.current = setTimeout(showNext, 10000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-[60] pointer-events-none" data-id="element-201">
      <AnimatePresence data-id="element-202">
        {current && <motion.div key={current.name + current.ago + indexRef.current} initial={{
        opacity: 0,
        x: -40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -40,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="pointer-events-auto flex items-center gap-3 bg-white rounded-2xl shadow-xl border border-stone-100 p-3 pr-4 max-w-[300px]" role="status" aria-live="polite" data-id="element-203">
            <div className="relative shrink-0" data-id="element-204">
              <img src={current.avatar} alt={current.name} width={48} height={48} loading="lazy" decoding="async" className="w-12 h-12 rounded-full object-cover" data-id="element-205" />
              <span className="absolute -bottom-0.5 -right-0.5 bg-emerald-500 text-white rounded-full p-0.5 border-2 border-white" data-id="element-206">
                <CheckCircle2 className="w-3.5 h-3.5" data-id="element-207" />
              </span>
            </div>
            <div className="min-w-0" data-id="element-208">
              <p className="text-sm text-stone-800 leading-tight" data-id="element-209">
                <strong className="font-bold" data-id="element-210">
                  {current.name} de {current.city}
                </strong>{' '}
                acaba de comprar el método
              </p>
              <p className="text-xs text-stone-400 mt-0.5" data-id="element-211">{current.ago}</p>
            </div>
            <button onClick={() => setCurrent(null)} aria-label="Cerrar notificación" className="text-stone-300 hover:text-stone-500 transition-colors shrink-0 self-start" data-id="element-212">
              <X className="w-4 h-4" data-id="element-213" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}